import { CheckCircle2, XCircle } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipTrigger } from '@shigo-ui/ui';

import { dashboardT } from '../../../../../lib/messages';
import { AdsTxtResultState, resolveAdsTxtResultState, type AdsTxtApp } from '../../model';

export function AdsTxtAppResult({ app }: { app: AdsTxtApp }) {
  const state = resolveAdsTxtResultState(app.adstxtFound ?? null, app.adstxtTotal ?? null);
  if (state === AdsTxtResultState.NotAvailable) {
    return <span className="text-muted-foreground">N/A</span>;
  }
  return state === AdsTxtResultState.Complete ? (
    <CheckCircle2
      className="mx-auto h-4 w-4 text-[var(--status-success-text)]"
      aria-label={dashboardT('adsTxt.complete')}
    />
  ) : (
    <XCircle
      className="text-destructive mx-auto h-4 w-4"
      aria-label={dashboardT('adsTxt.incomplete')}
    />
  );
}

export function AdsTxtAppTooltipCell({ value }: { value: string | null | undefined }) {
  if (!value) return '—';
  return (
    <Tooltip delayDuration={0}>
      <TooltipTrigger asChild>
        <button
          type="button"
          className="block w-full min-w-0 cursor-help truncate focus:outline-none focus-visible:ring-2"
        >
          {value}
        </button>
      </TooltipTrigger>
      <TooltipContent className="max-w-80 break-words whitespace-normal">{value}</TooltipContent>
    </Tooltip>
  );
}
